import Bloc from './Bloc.js';
import Types from './Types.js';

export default class LoseCorruption extends Bloc {

	constructor (src, ctx) {

		super("losecorruption", src, ctx, true);
		this.f = (src, ins) => {
			src.master.run.champion.loseCorruption(ins[0]);
			return [];
		};
		this.types = [Types.int];
	}
}